import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
}

export const TaskList = createSlice({
  name: '@TaskList',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1
    },
    decrement: (state) => {
      state.value -= 1
    },
    setCount: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { increment, decrement, setCount } = TaskList.actions

export default TaskList.reducer